import React from "react";
import RemoveStep from "../RemoveStep";
import DraggableField from "./DraggableField";
import { useWorkflowDialogState } from "../../hooks/useWorkflowDialogState";

const WorkflowSteps = ({
  edit,
  errors,
  fields,
  remove,
  close,
}) => {
  const removeStepDialog = useWorkflowDialogState();
  const [currentStep, setCurrentStep] = React.useState();

  return (
    <>
      {removeStepDialog.isOpen && (
        <RemoveStep
          close={close}
          currentStep={currentStep}
          fields={fields}
          showRemoveSteps={removeStepDialog.isOpen}
          setShowRemoveSteps={removeStepDialog.setOpen}
        />
      )}
      {fields &&
        fields.map((field, index) => (
          <DraggableField
            key={`draggable-field-${index}`}
            field={field}
            index={index}
            remove={remove}
            edit={edit}
            setOpenRemoveStep={removeStepDialog.setOpen}
            setCurrentStep={setCurrentStep}
            errors={errors}
          />
        ))}
    </>
  );
};

export default React.memo(WorkflowSteps);
